import Resource from '../../models/basic.js';
import _ from 'lodash';

class ecmRepository extends Resource {
    constructor(options) {
        const opts = _.defaults({}, options, {
            baseUrl: '/mtm-gateway-api/v1/services/ecm/ECMRepositories',         
            idField: 'repositoryId'
        });

        super(opts);
    }
    url() {
        return this.baseUrl + '/' + encodeURIComponent(this.get('repositoryId'));
    }

    fetch(id) {
        return super.fetch(id)
        .then(() => {
        
        });
    }
}

export default ecmRepository;

   
